export default class ScreenEffectsPipeline {}
